import { DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI } from '../../../types/default-cloud-graph-calendar-event-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import {
	GoogleCalendarIcon,
	GoogleCalendarIconBorderless,
	GoogleCalendarSearchResultIcon,
} from './icon';

export const googleCalendarConfig: ThirdPartyConfig = {
	displayName: 'Google Calendar',
	id: 'google-calendar',
	resourceType: ProductResourceTypes3P.GoogleCalendar,
	icon: get3PLogo(GoogleCalendarIcon, 'Google Calendar', 'medium'),
	iconBorderless: get3PLogo(GoogleCalendarIconBorderless, 'Google Calendar', 'small'),
	searchResultIcon: get3PLogo(GoogleCalendarSearchResultIcon, 'Google Calendar', 'large'),
	integrationAri: 'ari:cloud:platform::integration/google',
	requiresOauth: true,
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Calendar,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	isEnabled: () => true,
};
